function StandardizationString(string: string): string {
  return string
    .trim()
    .normalize("NFD")
    .replace(/\p{Diacritic}+/gu, "")
    .replace(/\s+/g, " ")
     .replace(/[`~!@#$%^&*()_|+=?;:'",.<>{}[\]\\/]/gi, "")
    .replace(/[–—]+/g, "-")
    .replace(/ /g, "-")
    .replace(/[-\s]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .toLowerCase();
}
// (SCRUM-658) was `module.exports = …` — the only CommonJS module in src/.
// Babel/webpack interoped the default-import consumers; native ESM (Vite dev)
// throws "does not provide an export named 'default'". Both importers use
// `import StandardizationString from …`, so a default export is drop-in.
export default StandardizationString;
